import axios from 'axios';

// In `npm start`, REACT_APP_URL from .env points at a local back-end (see .env.example).
// Builds always use the runtime config in public/config.js.
const devURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_URL : undefined;

// Keep every API and file URL on a single slash even when runtime config uses
// a trailing slash (for example, https://example.com/).
export const baseURL = (devURL || window.env.REACT_APP_URL).replace(/\/+$/, '');
export const baseURLFile = baseURL;

// Store keycloak instance
let keycloakInstance = null;

// Function to set keycloak instance
export const setKeycloakInstance = (keycloak) => {
  keycloakInstance = keycloak;
};

// Function to get current valid token
export const getCurrentToken = async () => {
  if (keycloakInstance && keycloakInstance.authenticated) {
    try {
      // This will refresh the token if it expires in < 5 minutes (300 seconds)
      await keycloakInstance.updateToken(300);
      return keycloakInstance.token;
    } catch (error) {
      console.error('Token refresh failed:', error);
      // Token refresh failed, logout user
      keycloakInstance.logout();
      throw error;
    }
  }
  return null;
};

const api = axios.create({
  baseURL: `${baseURL}/api`,
});

// Request interceptor to add fresh token to each request
api.interceptors.request.use(
  async (config) => {
    try {
      const token = await getCurrentToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      // If token refresh fails, reject the request
      return Promise.reject(error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // `keepSessionOn403`: the request handles a 403 itself (e.g. licenciamento shows "sem permissão").
    const status = error.response?.status;
    if (status === 401 || (status === 403 && !error.config?.keepSessionOn403)) {
      console.warn('Authentication error, logging out user');
      
      // Clear localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('User');
      
      // If we have keycloak instance, use it to logout
      if (keycloakInstance && keycloakInstance.authenticated) {
        keycloakInstance.logout();
      } else {
        // Fallback: reload page to trigger auth flow
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
